import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const data = [
  { TimePoint: 0, OD: 0.415, 'SDS': 58.1},
  { TimePoint: 24, OD: 0.407, 'SDS': 113.96},
  { TimePoint: 48, OD: 0.401, 'SDS': 112.28},
  { TimePoint: 72, OD: 0.428, 'SDS': 119.84},
  { TimePoint: 120, OD: 0.419, 'SDS': 117.32},
  { TimePoint: 148, OD: 0.438, 'SDS': 122.64},
  { TimePoint: 172, OD: 0.443, 'SDS': 124.04},
  { TimePoint: 196, OD: 0.44, 'SDS': 123.2},
];

function Figure10() {
  return (
    <div>
      <br></br>
      <p> <u>Figure 10: Culture OD evolution and Volume of SDS added over time (D1&D2 Domain)</u></p>
      <LineChart width={600} height={300} data={data} margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="TimePoint" type="number" label={{ value: 'TimePoint (hours)', position: 'BottomLeft' }}/>
        <YAxis yAxisId="left" label={{ value: 'OD (unitless)', angle: -90, position: 'left' }}/>
        <YAxis
          yAxisId="right"
          orientation="right"
          label={{ value: 'SDS (μL)', angle: -90, position: 'right' }}
        />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="OD" stroke="blue" yAxisId="left"/>
        <Line type="monotone" dataKey="SDS" stroke="red" yAxisId="right" />
        
      </LineChart>
    </div>
  );
}

export default Figure10;